var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolygone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(768 155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -112L97 -56L97 56L0 112L-97 56L-97 -56Z",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(227 113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -67L58 -33.5L58 33.5L0 67L-58 33.5L-58 -33.5Z",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448 307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -71L61.5 -35.5L61.5 35.5L0 71L-61.5 35.5L-61.5 -35.5Z",
    fill: "none",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(784 460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -103L89.2 -51.5L89.2 51.5L0 103L-89.2 51.5L-89.2 -51.5Z",
    fill: "none",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygone);
export default __webpack_public_path__ + "static/media/polygone.d617f5f9dcf20b09ab01cb58828b58e1.svg";
export { ForwardRef as ReactComponent };